<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
    >
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动名称">
            <a-input placeholder="请输入活动名称"
                     disabled v-decorator="['activityName',rules.activityName ]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item class="time-box" label="活动时间">
            <a-date-picker
                v-decorator="['activityStartTime', { rules: [{ required: true, message: '请选择活动开始时间' }] }]"
                :disabled-date="disabledStartDate"
                valueFormat="YYYY-MM-DD"
                placeholder="请选择活动开始时间"
                @change="startPanelChange"
                disabled
            />
            <a-date-picker
                v-decorator="['activityEndTime', { rules: [{ required: true, message: '请选择活动结束时间' }] }]"
                :disabled-date="disabledEndDate"
                valueFormat="YYYY-MM-DD"
                placeholder="请选择活动结束时间"
                @change="endPanelChange"
                disabled
            />
          </a-form-item>
        </a-col>

      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动类型">
            <a-input placeholder="请输入活动类型"
                     disabled v-decorator="['typeName' ]"/>
<!--            <a-cascader v-decorator="['typeName',rules.typeName]"-->
<!--                        placeholder="请选择活动类型"-->
<!--                        change-on-select-->

<!--                        :options="activityTypeData"-->
<!--                        :fieldNames="{ label: 'typeName', value: 'typeId', children: 'children' }"-->

<!--            />-->
          </a-form-item>
        </a-col>
      </a-row>
<!--      <a-row :gutter="24">-->
<!--        <a-col :span="20">-->
<!--          <a-form-item label="活动类别">-->
<!--            <a-select-->
<!--                v-decorator="['activityCategory', { rules: [{ required: true, message: '请选择活动类别' }] }]"-->
<!--                :options="activityCategoryArr">-->
<!--            </a-select>-->
<!--&lt;!&ndash;            <a-input placeholder="请选择活动类别" v-decorator="['activityCategory',rules.activityCategory ]"/>&ndash;&gt;-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--      </a-row>-->
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="品系">
            <a-select
                disabled
                v-decorator="['activityStrain',{ rules: [{ required: true, message: '请选择品系' }] }]"
                style="width: 250px"
                :options="activityStrainOption">
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="车型代码">
            <a-input disabled placeholder="请输入车型代码" :maxLength="20" v-decorator="['carNumber',rules.carNumber ]"/>
          </a-form-item>
        </a-col>
      </a-row>


      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="省市区">

          <a-cascader disabled
                      v-decorator="['mbrAreaList']"
                      placeholder="请选择所在区域"
                      :options="treeData"
                      :fieldNames="{ label: 'areaName', value: 'areaId', children: 'children' }"

          />
<!--            :disabled="show"-->
            </a-form-item>
        </a-col>
      </a-row>


      <a-row :gutter="24">
        <a-col :span="20">
          <a-form-item label="活动地点">
            <a-input disabled placeholder="请输入活动地点" v-decorator="['activityPlace',rules.activityPlace ]"/>
          </a-form-item>
        </a-col>
      </a-row>
<!--      <a-row :gutter="24">-->
<!--        <a-col :span="20">-->
<!--          <a-form-item label="客户窝子">-->
<!--            <a-input disabled placeholder="请输入客户窝子" v-decorator="['activityWoZi',rules.activityWoZi ]"/>-->
<!--          </a-form-item>-->
<!--        </a-col>-->
<!--      </a-row>-->
    </a-form>
    <a-space class="a-form-btn-box">
<!--      <a-button @click="endEdit('cancelled')">取消</a-button>-->
<!--      <a-button type="primary" @click="_save(false)">提交</a-button>-->
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
import {loadBaseCodeData,loadAreaTreeCasData,dealTreeNoChild} from "@/services/baseCodeSource";
//接口API
import {dataApi} from '@/services/activityManage/activityList';
import {XEUtils} from "@/utils/common/FormBase";

import moment from "moment";

function activityTypeRule(rule, value, callback) {
  // if(value.length === 1){
  //   callback("一级节点不能选择")
  // }else{
    callback()
  // }
}

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    activityName: {
      rules: [{required: true, whitespace: true, message: "请输入活动名称"}]
    },
    activityType: {
      rules: [{required: true,  message: "请选择活动类型"},
        {validator:activityTypeRule}]
    },
    activityPlace: {
      rules: [{required: true, whitespace: true, message: "请输入活动地点"}]
    },
    carNumber: {
      rules: [{required: true, whitespace: true, message: "请输入车型代码"}]
    },
    // activityCategory: {
    //   rules: [{required: true, message: "请选择活动类别" }]
    // },
    activityStrain: {
      rules: [{required: true, message: "请选择品系" }]
    },
    activityWoZi: {
      rules: [{required: false }]
    },
  };
}

function afterLoad(entity) {
  console.log(entity)
  if (entity.provinceId) {
    this.setFormValue({
      'mbrAreaList': [entity.provinceId, entity.cityId, entity.districtId]
    })
  }

}


function newEntity() {

  return {}
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  console.log('rowId', rowId);
  let entity = await dataApi.getFormDetail(rowId);
  if(entity.data.activityType){
    this.activityNo = entity.data.activityNo
    entity.data.activityType = XEUtils.findTree(this.activityTypeData, item => item.typeId === entity.data.activityType).nodes.map(item=>item.typeId);
  }
  // this.show = true;
  return fmt.formatFormLoad(entity);
}

/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  entities.activityType = Number(entities.activityType.split(',')[entities.activityType.split(',').length-1])
  entities.acitvityId = vm.keyId; //更新--没拼错，数据库就是这个字段
  if (entities.mbrAreaList) {
    entities.provinceId = entities.mbrAreaList.split(',')[0];
    entities.cityId = entities.mbrAreaList.split(',')[1];
    entities.districtId = entities.mbrAreaList.split(',')[2];
  }
  entities.activityNo = this.activityNo; //更新
  entities.activityStartTime = entities.activityStartTime + ' 00:00:00' ;
  entities.activityEndTime = entities.activityEndTime + ' 23:59:59' ;
  if(entities.activityId){
    return await dataApi.saveFormDetail(entities,true);
  }else{
    return await dataApi.saveFormDetail(entities,false);
  }

}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  let allData = await dataApi.getActType()
  this.allActivityTypeData = allData.data;
  this.activityCategoryArr = await loadBaseCodeData('CD400003');
  this.activityTypeData = XEUtils.toArrayTree(allData.data, {
    key: 'typeId',
    parentKey: 'parentId',
    children: 'children'
  })
  this.treeData = await loadAreaTreeCasData();
  dealTreeNoChild(this.treeData)
  //品系
  this.activityStrainOption = await dataApi.selectionStrain();//品系
  this.activityStrainOption = this.activityStrainOption.data.map(v => {
    return {
      label: v.strainName,
      value: v.strainId
    }
  })
}



/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['selectedObj'],
  data() {
    return {
      treeData:[],
      activityTypeData: [],//活动类型数据
      activityTypeDefault: [],//默认的活动类型
      activityNo: '',//活动编号
      show: false,
      startValue: null,
      endValue: null,
      // activityCategoryArr: [],//活动类别
      activityStrainOption:[],


    }
  },
  async mounted() {
    const todayDate = new Date().valueOf()
    console.log('==============================='+todayDate)
  },
  methods: {
    newEntity,
    loadEntity,
    loadBaseData,
    save,
    afterLoad,
    getRulesTemplate,
    startPanelChange(value){
      this.startValue = new Date(value).valueOf()
    },
    endPanelChange(value){
      this.endValue = new Date(value).valueOf()
    },

    disabledDate(current) {
      return current && current <= moment().startOf("day"); // 当前时间之前的所有日期都禁用
    },
    disabledStartDate(startValue) {
      // const todayDate = new Date().valueOf()
      const endValue = this.endValue;
      const monthTime = this.getMonthTime(endValue)
      if (!startValue || !endValue) {
        return startValue <= moment().startOf("day")
      }
      console.log('this.disabledDate(startValue)===============================================')
      console.log('this.disabledDate(startValue)')

      return ( startValue <= moment().startOf("day"))||(startValue.valueOf() <= monthTime[0] || startValue.valueOf() >= endValue.valueOf());
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      const monthTime = this.getMonthTime(startValue)
      if (!endValue || !startValue) {
        return endValue <= moment().startOf("day")
      }
      return (endValue <= moment().startOf("day")||(startValue.valueOf() >= endValue.valueOf() || endValue.valueOf() >= monthTime[1]));
    },
    getMonthTime(value){
      if(!value){
        return false;
      }
      let time = new Date(value);//当前月 要计算其他时间点自己传入即可
      let year = time.getFullYear();
      let month = parseInt( time.getMonth() + 1 );

//开始时间 时间戳
      let start = new Date( year + "-" + month + "-01 00:00:00" ).getTime()
//结束时间 时间戳
      if( month == 12 ){
        //十二月的时候进位，这里直接用加减法算了
        //也可以用 time.setMonth( month + 1 )去计算并获取结束时间的月份和年份
        month = 0;
        year += 1;
      }
      let end = new Date( year + "-" + ( month + 1 )  + "-01 00:00:00" ).getTime()
      return [start,end]
    }
  },
};
</script>

<style scoped lang="less">

  .time-box{
    .ant-calendar-picker{
      width: 47%;
      &:first-child{
        margin-right: 6%;
      }
    }
  }

</style>
